<template lang="html">
    <div class="quick-banner">
        <div class="container">
            <header>
                <h1>听力下载</h1>
                <template v-if="urlParams.type=='cn'">
                    <div class="bottom-nav">
                        <div class="bottom-type" :class="{active: generalId==''}">
                            <p @click="findinfo('')">全部</p>
                        </div>
                        <div v-for="one in generaldata" class="bottom-type" :class="{active: generalId==one.id}">
                            <p @click="findinfo(one.id)">{{one.name}}</p>
                        </div>
                    </div>
                </template>
            </header>
        </div>
    </div>
    <div class="container" style="margin:40px auto;">
        <!--<div class="row">
            <div class="col-xs-2 listenImg" v-for="infodata in infodata">
                <a v-link="{path :'/index/listenbookpc?id='+infodata.id}">
                    <img :src="infodata.logo" style="height: 150px;"/>
                    <img class="imgJif" src="../assets/dw.gif"/>
                    <p><small style="color: red;">【{{infodata.versionId}}】</small> {{infodata.name}}</p>
                </a>
            </div>
        </div>-->
        <div v-if="!infodata||!infodata.length" style="text-align: center;">暂无数据</div>
        <div class="row">
            <div class="col-xs-2 listenImg" v-for="infodata in infodata">
                <div class="show-block">
                    <a v-link="{path :'/index/listenbookpc?id='+infodata.id+'&name='+infodata.name}">
                        <img :src="infodata.logo" style="height: 150px;"/>
                        <!--<img class="imgJif" src="../assets/dw.gif"/>-->
                        <div class="float-title">
                            【{{infodata.versionId}}】{{infodata.name}}
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <page :turn-page="pageData"></page>
    </div>
</template>
<script>
    import M from '../assets/common.js'
    import C from '../assets/config.js'
    import page from '../components/page.vue'

    export default {
        data: () => ({
            postParam: {},
            host: C.host,
            pageData: {},
            infodata: {},
            databanben: {},
            generaldata: {},
            generalId: 1,
            pageNo: 1,
            urlParams: M.getUrlParams()
        }),
        events: {
            'child-turn-page'(obj) {
                this.pageNo = obj.pageNo;
                this.findinfo(this.generalId);
            },
        },
        components: {
            page,
        },
        created: function () {
            this.findbanben();
            this.findgeneral();
        },
        ready: function () {
            window.addEventListener('hashchange', ()=>{
                this.urlParams = M.getUrlParams();
                this.findbanben();
                if(this.urlParams.type=='cn'){
                    $('.topnav ul li').eq(2).removeClass('active');
                }else{
                    $('.topnav ul li').eq(3).removeClass('active');
                }
            });
            if(this.urlParams.type=='cn'){
                $('.topnav ul li').eq(2).removeClass('active');
            }else{
                $('.topnav ul li').eq(3).removeClass('active');
            }
        },
        methods: {
            //
            findgeneral: function () {
                let url = this.host + 'wuyan/user/general';
                let self = this;
                let postParam = {};
                M.load(url, '', function (data) {
                    self.$set('generaldata', data.data)
                }, 'get');
            },
            //查询 版本
            findbanben: function () {
                let url = this.host + 'wuyan/admin/version';
                let self = this;
                let postParam = {};
                M.load(url, postParam, function (data) {
                    self.$set('databanben', data.data)
                    self.findinfo();
                }, 'get');
            },
            findinfo: function (generalId) {
                this.generalId = generalId ? generalId : '';
                let url = this.host + 'wuyan/user/listen';
                let self = this;
                let postParam = {};
                postParam.generalId = this.generalId * 1;
                postParam.subjectId = this.urlParams.type == 'en'?3:1;
                postParam.pageNo = this.pageNo * 1;
                postParam.pageSize = 20;
                M.load(url, postParam, function (data) {
                    if (data.hasOwnProperty('code')) {
                        data.data = {list: [], pageNO: 1, totalCount: 0};
                    }
                    self.$set('infodata', data.data.list)
                    self.$set('pageData', data.data)
                    self.infodata.forEach(function (a) {
                        self.databanben.forEach(function (b) {
                            if (b.id == a.versionId) {
                                a.versionId = b.name;
                            }
                        })
                    })
                }, 'get');
            },
        }
    }
</script>
<style scoped>

    /*头部次级导航*/
    .quick-banner {
        font-family: 微软雅黑;
        background-attachment: fixed;
        background-color: #3dccac;
        background-image: url(http://qiniu.ludanmall.com/472/shop/cube/Artboard%201_1479995902886.svg);
        padding-top: 50px;
        padding-bottom: 10px;
    }

    .quick-banner h1 {
        color: white;
        text-align: center
    }

    .bottom-nav {
        border-top: 2px solid white;
        margin-top: 60px
    }

    .bottom-type {
        color: white;
        padding: 5px;
        display: inline-block;
        margin: 5px 0;
        width: 14%;
        text-align: center;
        cursor: pointer;
    }
    .bottom-type.active {
        border-top: 2px solid #337ab7;
        margin: 0;
        color: #337ab7;
    }
    .bottom-type p {
        margin: 0;
        font-size: 18px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .row {
        margin: 0;
        padding: 0;
    }

    a:hover {
        text-decoration: none;
    }

    .show-block {
        position: relative;
        box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.4);
        min-height: 151px;
        margin: 15px 0;
    }

    .show-block img {
        height: 160px;
        display: block;
        margin: auto;
    }

    .float-title {
        background: rgba(0, 0, 0, 0.8);
        text-decoration: none;
        color: white;
        position: relative;
        width: 100%;
        height: 40px;
        bottom: 0px;
        font-family: 微软雅黑;
        font-size: 12px;
        word-wrap: break-word;
        display: flex;
        align-items: center;
    }

    /*.listenImg{
        text-align: center;
    }
    .listenImg a{
        text-decoration: none;
        color: #000;
    }
    .listenImg img {
        width: 100%;
    }
    .listenImg p{
        background: #fff;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
    }
    .listenImg .imgJif{
        position: absolute;
        width: 70px;
        top: 35%;
        left: 70px;
    }*/
</style>


// WEBPACK FOOTER //
// listendownpc.vue?33c4806d